import { useEffect, useState, type ComponentProps } from 'react';

import defu from 'defu';
import _ from 'lodash';

import apiFetch from '@wordpress/api-fetch';

import { type FaqsType, type FaqsVariations } from '@/src/Types/Blocks/Faqs';
import { type ContainerTypeEnums, type PositionsAlignement } from '@/src/Types/Shared/Common';
import type { Options } from '@/src/Types/Shared/Options';
import { type QueryPost, type QueryType } from '@/src/Types/Shared/Query';
import { FaqsStyle, getBtnStyle, getSingleBtnStyle } from '@Views/Shared/GlobalStyles/GlobalStyles';

import Block from './Block';

declare const current_lang: string;
declare const translated_cpts: string;

type FaqRegister = {
	block: FaqsType;
	variant: FaqsVariations;
	containerType: ContainerTypeEnums;
	headingAlign: PositionsAlignement;
	options: Options;
};
export default function Faqs(props: FaqRegister) {
	const {
		block,
		variant = 'classic',
		containerType = 'wide',
		headingAlign = 'center',
		options,
	} = props;

	const {
		id,
		title,
		description,
		titleFormat = 'h2',
		postsNumber,
		types_faq,
		order = 'asc',
		orderBy,
		isManual,
		posts: postIn,
		composition,
	} = block;

	const [posts, setPosts] = useState<QueryPost[] | undefined>();
	const [linkIndex, setLinkIndex] = useState<string>('');

	useEffect(() => {
		const _data: Promise<string> = apiFetch({
			path: '/minos/v2/geturl/',
			method: 'POST',
			data: {
				type: 'faq',
			},
		});
		_data.then((url) => {
			setLinkIndex(url);
		});
	}, []);

	useEffect(() => {
		const _posts: Promise<QueryType> = apiFetch({
			path: '/minos/v2/getposts/',
			method: 'POST',
			data: {
				args: {
					post_type: ['faq'],
					posts_per_page: isManual ? -1 : postsNumber,
					orderby: orderBy,
					order: order,
					isManual: isManual,
					postIn: postIn,
					taxs: {
						type_faq: types_faq,
					},
					lang: current_lang && JSON.parse(translated_cpts).includes('faq') ? current_lang : '',
				},
			},
		});
		_posts.then((data) => {
			setPosts(data.posts);
		});
	}, [block]);

	let propsBlock: ComponentProps<typeof Block> = {
		id: id ? id : '',
		title: title,
		description: description,
		titleFormat: titleFormat,
		posts: posts,
		containerType: containerType,
		variant: variant,
		headingAlign: headingAlign,
		linkIndex: linkIndex,
		contentFontFormats: block.contentFontFormats,
		archiveLink: block.archiveLink,
		archiveLinkStyles: getSingleBtnStyle(options, options.blocks.faqs.default.archiveLinkStyles),
		ctasStyle: getBtnStyle(options, options.blocks.faqs.default.ctasStyle),
		placement: block.placement,
		sectionDecoration: options.layout.sectionDecoration,
	};

	if (composition && composition != 'none') {
		const compoOptions = _.find(options.blocks.faqs.compositions, { id: composition });
		if (compoOptions) {
			propsBlock = defu(compoOptions as ComponentProps<typeof Block>, propsBlock);
			propsBlock.ctasStyle = getBtnStyle(options, compoOptions.ctasStyle);
			propsBlock.style = FaqsStyle(options, compoOptions);
			propsBlock.archiveLinkStyles = getSingleBtnStyle(options, compoOptions.archiveLinkStyles);
		}
	}

	return <Block {...propsBlock} />;
}
